const AdminAnalyticsPage = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Analytics</h1>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {/* Temporary analytics cards */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-medium text-gray-900">User Growth</h2>
          <p className="mt-2 text-sm text-gray-500">Temporary placeholder for user growth chart</p>
          <div className="mt-4 h-64 bg-gray-100 rounded flex items-center justify-center">
            Chart placeholder
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-medium text-gray-900">Lesson Completion Rates</h2>
          <p className="mt-2 text-sm text-gray-500">Temporary placeholder for completion rates chart</p>
          <div className="mt-4 h-64 bg-gray-100 rounded flex items-center justify-center">
            Chart placeholder
          </div>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-medium text-gray-900">Popular Lessons</h2>
          <p className="mt-2 text-sm text-gray-500">Most accessed lessons this month</p>
          <ul className="mt-4 space-y-3">
            <li className="flex justify-between">
              <span>Introduction to Algebra</span>
              <span className="text-gray-500">250 views</span>
            </li>
            <li className="flex justify-between">
              <span>Basic Geometry</span>
              <span className="text-gray-500">180 views</span>
            </li>
            <li className="flex justify-between">
              <span>Advanced Equations</span>
              <span className="text-gray-500">150 views</span>
            </li>
          </ul>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-medium text-gray-900">User Activity</h2>
          <p className="mt-2 text-sm text-gray-500">Daily active users</p>
          <div className="mt-4 h-64 bg-gray-100 rounded flex items-center justify-center">
            Chart placeholder
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAnalyticsPage;
